import { render, staticRenderFns } from "./AppProfilePicture.vue?vue&type=template&id=6b3be209&scoped=true&"
import script from "./AppProfilePicture.vue?vue&type=script&lang=js&"
export * from "./AppProfilePicture.vue?vue&type=script&lang=js&"
import style0 from "./AppProfilePicture.vue?vue&type=style&index=0&id=6b3be209&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3be209",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAvatar,VIcon,VImg})
